import {
  APP_BTN_OUTLINE_CLASS,
  APP_INPUT_CLASS,
  APP_TEXTAREA_CLASS,
} from '../../../../ui/controlStyles';

/** Gemeinsame Klassen für Formularfelder und Buttons in der Projekt-Detailansicht. */

export const LEAD_DETAIL_INPUT_CLASS = APP_INPUT_CLASS;

export const LEAD_DETAIL_TEXTAREA_CLASS = APP_TEXTAREA_CLASS;

export const LEAD_DETAIL_LABEL_CLASS = 'mb-1 block text-sm font-medium text-app-text-muted';

export const LEAD_DETAIL_BTN_PRIMARY =
  'inline-flex h-9 items-center justify-center gap-2 shrink-0 rounded-md bg-pipedrive-green px-3.5 text-sm font-semibold text-white hover:bg-[#218838] disabled:opacity-40 transition-colors';

export const LEAD_DETAIL_BTN_OUTLINE = APP_BTN_OUTLINE_CLASS;
